import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FadeIn from "../Animations/FadeIn";

import { GetMarketplaceProductCards } from "../DataService/ProductCardService";
import { ProductCardModel, mapPublicProductCardToModel } from "../Types/ProductCardRenderingTypes";
import * as React from 'react'
import { ProductCard } from "../Components/CourseRender";
import './MarketPlace.css'
import { useCart } from "../DataService/CartContext";
import { CartItem } from "../Types/CartTypes";
import { CourseStatus } from "../Types/CourseTypes";
import { Button } from "../Components/Button";
// import { ProductCard } from "../Components/product-card/ProductCard";
// import { GetMarketplaceProductCards } from "../DataService/ProductCardService";
// import { mapPublicProductCardToModel } from "../mappers/productCard.mapper";
// import { ProductCardModel } from "../Types/ProductCardModel";
// import FadeIn from "../Components/Animations/FadeIn";

export const Marketplace = () => {
  const [cards, setCards] = useState<ProductCardModel[]>([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { replacePayableItem, totalItems } = useCart();

  const loadCards = async () => {
    setLoading(true);
    setLoadError(null);

    try {
      const res = await GetMarketplaceProductCards();
      const mapped = (res ?? [])
        .filter(card => card.status === CourseStatus.Published)
        .map(mapPublicProductCardToModel);

      setCards(mapped);
    } catch {
      setLoadError('Vi kunde inte läsa in kurser just nu. Försök igen om en stund.');
      setCards([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCards();
}, []);

  if (loading) {
    return <div className="text-center py-20">Vi laddar kurserna åt dig…</div>;
  }

  return (
      <div className="marketplace-page">
        {/* HERO */}
        <div className="marketplace-hero">
          <FadeIn>
            <div className="marketplace-hero-inner marketplace-hero-grid">
              <div className="marketplace-hero-copy">
              <p className="marketplace-hero-kicker">Kuraterat urval</p>
              <h1 className="marketplace-hero-title">Kurser</h1>
              <p className="marketplace-hero-subtitle">
                Ett utvalt bibliotek av kurser för dig som vill fördjupa dig i lugn och ro.
              </p>
              <div className="marketplace-hero-actions">
                <Button
                  type="button"
                  variant="ghost"
                  size="md"
                  className="marketplace-cart-button"
                  onClick={() => navigate('/cart')}
                  text={<>Visa korgen {totalItems > 0 ? `(${totalItems})` : ''}</>}
                />
                <span className="marketplace-owned-hint">Om du redan äger en kurs hittar du den i din medlemsportal.</span>
              </div>
              </div>
            </div>
          </FadeIn>
        </div>

      {/* GRID */}
      <div className="marketplace-content">
        <div className="marketplace-toolbar">
          <div>
            <span className="marketplace-toolbar-label">Tillgängligt</span>
            <span className="marketplace-toolbar-count">{cards.length} kurser</span>
          </div>
          <div className="marketplace-toolbar-note">Utvalt för dig, med tydlig väg vidare till kurs eller medlemsportal.</div>
        </div>

        {loadError ? (
          <div className="marketplace-state-card">
            <h2>Vi kunde inte läsa in kurserna</h2>
            <p>{loadError}</p>
            <button type="button" className="marketplace-state-button" onClick={loadCards}>
              Försök igen
            </button>
          </div>
        ) : cards.length === 0 ? (
          <div className="marketplace-state-card">
            <h2>Inga kurser att visa just nu</h2>
            <p>
              Vi har inga publicerade kurser att visa just nu.
              Kom gärna tillbaka senare eller kontakta oss om du vill veta vad som är på väg.
            </p>
          </div>
        ) : (
          <div className="marketplace-grid">
            {cards.map((card) => (
              <div key={card.courseId} className="marketplace-card-shell">
                <ProductCard
                  {...card}
                  onPrimaryAction={() =>
                    card.mode === "owned"
                      ? navigate('/member-home')
                      : (() => {
                          const price = Number(String(card.price ?? '0').replace(/[^\d,.-]/g, '').replace(',', '.')) || 0;
                          const item: CartItem = {
                            id: `course-${card.courseId}`,
                            type: 'course',
                            referenceId: String(card.courseId),
                            title: card.title,
                            description: card.description,
                            price,
                            quantity: 1,
                            courseId: card.courseId,
                          };

                          replacePayableItem(item);
                          navigate('/cart');
                        })()
                  }
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>

  );
};
